import axios from "axios";

import { SERVICE_URL, STATUS_CODE, AI_BASE_URL, STAGE_URL, TEMP_URL  } from "common/Constants";

export const CALL_API = async (action, method, payload) => {
  try {
    const resp = await axios({
      method,
      url: `${SERVICE_URL}${action}`,
      data: payload,
      headers: {
        Tymeplusjwt: window.localStorage.getItem("token") || "",
      },
    });
    const { status, response } = resp.data;
    if (status === STATUS_CODE.SUCCESS || status === true) return response;
    return { status, response };
  } catch (err) {
    console.log(err);
    console.log(action);
    return err?.response?.data ?? err;
  }
};

const USER_LIST_PAGE_SIZE = 100;

// GET master-data/user-list/{clientid}
export const FETCH_FULL_USER_LIST = async (clientId) => {
  return await CALL_API(`master-data/user-list/${clientId}`, "get");
};

// GET master-data/user-list/{clientid}?statusid= — same paginated, full-field
// (~150 fields) roster endpoint as FETCH_FULL_USER_LIST, but filtered
// server-side to one statusid. Used for the People page's CSV export so the
// export can pull full employee detail on demand for just the active tab,
// without needing the rich fields preloaded for the whole roster.
export const FETCH_FULL_USER_LIST_BY_STATUS = async (clientId, statusId) => {
  let userList = [];
  let lastEvaluatedKey = null;
  let result;
  do {
    const query = new URLSearchParams({
      limit: USER_LIST_PAGE_SIZE,
      statusid: statusId,
    });
    if (lastEvaluatedKey) {
      query.set("lastEvaluatedKey", lastEvaluatedKey);
    }
    result = await CALL_API(`master-data/user-list/${clientId}?${query.toString()}`, "get");
    if (result?.code !== STATUS_CODE.SUCCESS) {
      return result;
    }
    userList = userList.concat(result?.userList || []);
    lastEvaluatedKey = result?.LastEvaluatedKey || null;
  } while (lastEvaluatedKey);
  return { ...result, userList };
};

// GET get-users?clientid=&statusid= is paginated server-side (see
// handlers/tymeplusOwnerUsers/app.js) and returns only the lean fields the
// People card view needs. Unlike FETCH_FULL_USER_LIST(_BY_STATUS) this makes
// exactly ONE call per invocation instead of walking every page up front —
// the People card view fetches one page on load and one more per "next"
// click, passing the previous response's LastEvaluatedKey back as the cursor.
// `filters` is the People-page filter bar's selections, e.g.
// { managingoffice: ["Kenya"], grade: ["A1"], supervisor: ["emp123"], ... } —
// each non-empty array is sent as a comma-separated value list and matched
// server-side (see getUser's addContainsAnyClause/addInClause).
export const FETCH_USERS_PAGE = async (clientId, statusId, cursor, filters = {}) => {
  const query = new URLSearchParams({ clientid: clientId, statusid: statusId });
  if (cursor) {
    query.set("LastEvaluatedKey", JSON.stringify(cursor));
  }
  Object.entries(filters || {}).forEach(([key, values]) => {
    if (Array.isArray(values) && values.length > 0) {
      query.set(key, values.join(","));
    }
  });
  return await CALL_API(`get-users?${query.toString()}`, "get");
};

// GET filterlist?clientid=&statusid=&managingoffice=&jobTitle=&engagementStatus=&
// userid=&grade=&... — dedicated People-page filter endpoint (see
// handlers/tymeplusOwnerUsers/app.js getFilterList), kept separate from
// get-users so that endpoint's behavior/contract doesn't change. Unlike
// FETCH_USERS_PAGE, a filtered view is NOT paginated in the UI — every match
// is listed at once. The backend already walks every LastEvaluatedKey page
// internally and returns the whole filtered set in one response, but this
// loops defensively (matching FETCH_FULL_USER_LIST_BY_STATUS's pattern) in
// case a very large match set ever comes back split across pages.
export const FETCH_FILTER_LIST = async (clientId, statusId, filters = {}) => {
  let userList = [];
  let lastEvaluatedKey = null;
  let result;
  do {
    const query = new URLSearchParams({ clientid: clientId, statusid: statusId });
    if (lastEvaluatedKey) {
      query.set("LastEvaluatedKey", JSON.stringify(lastEvaluatedKey));
    }
    Object.entries(filters || {}).forEach(([key, values]) => {
      if (Array.isArray(values) && values.length > 0) {
        query.set(key, values.join(","));
      }
    });
    result = await CALL_API(`filterlist?${query.toString()}`, "get");
    if (result?.code !== STATUS_CODE.SUCCESS) {
      return result;
    }
    userList = userList.concat(result?.response || []);
    lastEvaluatedKey = result?.LastEvaluatedKey || null;
  } while (lastEvaluatedKey);
  return { ...result, userList };
};

// GET export-userlist?clientid=&statusid= — People-page CSV export endpoint
// (see handlers/tymeplusOwnerUsers/app.js getExportUserList). Ignores the
// filter bar entirely and just returns every field on every Employee record
// for the given status (Employee/Ex Employee tab) — same defensive
// pagination loop as FETCH_FILTER_LIST above.
export const FETCH_EXPORT_USER_LIST = async (clientId, statusId) => {
  let userList = [];
  let lastEvaluatedKey = null;
  let result;
  do {
    const query = new URLSearchParams({ clientid: clientId, statusid: statusId });
    if (lastEvaluatedKey) {
      query.set("LastEvaluatedKey", JSON.stringify(lastEvaluatedKey));
    }
    result = await CALL_API(`export-userlist?${query.toString()}`, "get");
    if (result?.code !== STATUS_CODE.SUCCESS) {
      return result;
    }
    userList = userList.concat(result?.response || []);
    lastEvaluatedKey = result?.LastEvaluatedKey || null;
  } while (lastEvaluatedKey);
  return { ...result, userList };
};

export const CALL_FEATCH_API = async (action, method, payload) => {
  try {
    const resp = await axios({
      method,
      url: `${SERVICE_URL}${action}`,
      data: payload,
      headers: {
        Tymeplusjwt: window.localStorage.getItem("token") || "",
      },
    });
    // const { status, response } = resp.data;
     return resp.data;
    
  } catch (err) {
    console.log(err);
    console.log(action);
    return err;
  }
};

export const CALL_API_UPDATED = async (action, method, payload) => {
  try {
    const resp = await axios({
      method,
      url: `${SERVICE_URL}${action}`,
      data: payload,
      headers: {
        Tymeplusjwt: window.localStorage.getItem("token") || "",
      },
    });
    return resp.data

  } catch (err) {
    throw err;
  }
};

export const CALL_AI_API = async (action, method, payload) => {
  try {
    const resp = await axios({
      method,
      url: `${AI_BASE_URL}${action}`,
      data: payload,
      headers: {
        Tymeplusjwt: window.localStorage.getItem("token") || "",
      },
    });
    const { status, response } = resp.data;
    if (status === STATUS_CODE.SUCCESS || status === true) return response;
    return { status, response };
  } catch (err) {
    console.log(err);
    console.log(action);
    return err?.response?.data ?? err;
  }
};

export const CALL_API_WITH_HEADER = async (
  action,
  method,
  payload,
  additionalHeaders
) => {
  try {
    const resp = await axios({
      method,
      url: `${SERVICE_URL}${action}`,
      data: payload,
      headers: {
        Tymeplusjwt: window.localStorage.getItem("token") || "",
        ...additionalHeaders,
      },
    });
    const { status, response } = resp.data;
    if (status === STATUS_CODE.SUCCESS) return response;
    return { status, response };
  } catch (err) {
    console.log(err);
    return err?.response?.data ?? err;
  }
};

export const UPLOAD_DOCUMENT = async (action, file) => {
  try {
    let data = new FormData();
    data.append("file", file);

    const resp = await axios.post(`${SERVICE_URL}${action}`, data, {
      Tymeplusjwt: window.localStorage.getItem("token") || "",
      "Content-Type": "multipart/form-data",
    });
    const { status, response } = resp.data;
    if (status === STATUS_CODE.SUCCESS) return response;
    return { status, response };
  } catch (err) {
    return err?.response?.data ?? err;
  }
};
